import { memo, useEffect } from "react";

import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css";

const SyntaxHighlighter = ({ className, code, language }) => {
  useEffect(() => {
    Prism.highlightAll();
  }, [code]);

  return (
    <pre {...{ className }}>
      <code className={`language-${language}`}>{code}</code>
    </pre>
  );
};

export default memo(SyntaxHighlighter);
